// Parse bulk-edit field values into task update payloads.
import { buildNameMapForTerms } from '@/services/tagNameUtils';
import { parseDurationFieldHandler } from './taskBulkEditDurationUtils';

export { isDurationFieldInvalid } from './taskBulkEditDurationUtils';

/**
 * Extract unique project and context identifiers from a list of tasks.
 * Used by TaskBulkEditModal to populate dropdown options.
 */
export function extractProjectContextFromTasks(tasks) {
  const projects = new Set();
  const contexts = new Set();

  for (const task of tasks) {
    if (task.projects && Array.isArray(task.projects)) {
      task.projects.forEach((p) => projects.add(p));
    }
    if (task.contexts && Array.isArray(task.contexts)) {
      task.contexts.forEach((c) => contexts.add(c));
    }
  }

  return {
    allProjects: Array.from(projects),
    allContexts: Array.from(contexts),
  };
}

export const parseDate = (dateStr) => {
  if (!dateStr) return null;
  const [year, month, day] = dateStr.split('-').map(Number);
  return new Date(Date.UTC(year, month - 1, day));
};

const parseDateFieldHandler = (value, updates, untouchedSymbol) => {
  if (value !== untouchedSymbol) updates.date = parseDate(value);
};

const parseStatusFieldHandler = (value, updates, untouchedSymbol) => {
  if (value !== untouchedSymbol && value !== '') updates.status = value;
};

const parseProjectFieldHandler = (value, updates, untouchedSymbol) => {
  if (value !== untouchedSymbol) updates.projects = value ? [value.trim()] : [];
};

const parseContextFieldHandler = (value, updates, untouchedSymbol) => {
  if (value !== untouchedSymbol) updates.contexts = value ? [value.trim()] : [];
};

const parsePersonFieldHandler = (value, updates, untouchedSymbol) => {
  if (value !== untouchedSymbol) updates.person = value ? value.trim() : null;
};

export const buildFieldUpdates = (fields, updates, untouchedSymbol) => {
  /** @type {[string, (value: any, updates: any, untouched: symbol) => void][]} */
  const fieldHandlers = [
    ['date', parseDateFieldHandler],
    ['duration', parseDurationFieldHandler],
    ['status', parseStatusFieldHandler],
    ['project', parseProjectFieldHandler],
    ['context', parseContextFieldHandler],
    ['person', parsePersonFieldHandler],
  ];

  for (const [field, handler] of fieldHandlers) {
    handler(fields[field], updates, untouchedSymbol);
  }
};

/**
 * @param {Record<string, unknown>} fields
 * @param {symbol} untouchedSymbol
 */
export const applyBulkTagTerms = async (updates, user, ensureTermsExist) => {
  if (!user) return;
  if (updates.projects?.length) {
    await ensureTermsExist(
      updates.projects,
      'projects',
      user.uid,
      buildNameMapForTerms(updates.projects, updates.projectNames),
    );
  }
  if (updates.contexts?.length) {
    await ensureTermsExist(
      updates.contexts,
      'contexts',
      user.uid,
      buildNameMapForTerms(updates.contexts, updates.contextNames),
    );
  }
};
